import { css } from 'styled-components';
import { theme } from "./theme";
/**
 * The assumption here is that fonts are being served
 * at the root public directory, which is what we are
 * currently doing in storybook. Ideally these fonts
 * will eventually be served via CDN and linked here.
 */

export var baseFontFamily = 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", ui-sans-serif';
export var baseFontStyles = css(["font-family:", ";font-synthesis:none;-webkit-font-smoothing:antialiased;text-size-adjust:none;color:", ";"], baseFontFamily, theme.colors.palette.grey90);